(function () {
  'use strict';

  var SELF_SRC = document.currentScript && document.currentScript.src ? document.currentScript.src : '';

  var BRAND_CODES = {
    '13': 'C.P. Company Under 16',
    '14': 'Stone Island Denims',
    '15': 'Stone Island',
    '16': 'Stone Island Junior',
    '18': 'C.P. Company (legacy)',
    '19': 'Stone Island Shadow Project',
    '20': 'C.P. Company Donna',
    '21': 'World Wide Web',
    '25': 'Stone Island Limited Editions',
    '26': 'Stone Island Serie 100'
  };

  var TYPE_CODES = {
    '0': 'Leather',
    '1': 'Shirts / overshirts',
    '2': 'T-shirts / polos',
    '3': 'Trousers',
    '4': 'Jackets / outerwear',
    '5': 'Knitwear',
    '6': 'Sweatshirts / fleece',
    '7': 'Long coats / parkas',
    '8': 'Suits',
    '9': 'Bags / hats / accessories',
    'A': 'Jacket / blazer',
    'B': 'Swimming trunks',
    'G': 'Gilet / waistcoat',
    'L': 'Bermuda shorts',
    'M': 'Jacket',
    'Q': 'Jacket / outerwear',
    'S': 'Shoes'
  };

  var NEW_PREFIXES = {
    'K1S': 'Spring/Summer 2025',
    'K2S': 'Autumn/Winter 2025/26',
    'L1S': 'Spring/Summer 2026',
    'L2S': 'Autumn/Winter 2026/27'
  };

  function cleanCode(value) {
    return String(value || '')
      .toUpperCase()
      .trim()
      .replace(/^ART(?:ICLE)?[.\s:-]*/i, '')
      .replace(/[\s.\-_/]/g, '');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function token(code, label) {
    return '<span class="sg-art-checker__token"><code>' + escapeHtml(code) + '</code><span>' + escapeHtml(label) + '</span></span>';
  }

  function exactReference(code) {
    var index = window.SG_ART_REFERENCES || {};
    if (!Object.prototype.hasOwnProperty.call(index, code)) return null;
    var row = index[code];
    var pageCodes = window.SG_ART_REFERENCE_PAGE_CODES || {};
    return {
      season: row[0],
      name: row[1],
      type: row[2],
      range: row[3],
      active: window.SG_ART_REFERENCE_PAGES_ACTIVE === true && pageCodes[code] === true
    };
  }

  function legacyCollection(code) {
    var n = parseInt(code, 10);
    if (!Number.isFinite(n) || n < 0 || n > 81) return null;
    var year = 1984 + Math.floor(n / 2);
    return (n % 2 === 0 ? 'Spring/Summer ' : 'Autumn/Winter ') + year;
  }

  function decodeExact(code, exact) {
    return {
      code: code,
      format: 'Verified exact reference',
      collection: exact.season,
      brand: exact.range || 'Stone Island',
      type: exact.type,
      range: 'Audited exact match',
      tokens: [
        ['Season', exact.season],
        ['Model', exact.name],
        ['Type', exact.type]
      ],
      exact: exact
    };
  }

  function decodeGeneric(code) {
    if (!code) return { error: 'Enter an ART number to decode.' };

    if (/^CLG/.test(code) || /^\d{12}$/.test(code)) {
      return { error: 'That looks like a Certilogo/CLG code, not an ART number. Use the official Stone Island authentication service for CLG codes.' };
    }

    var newMatch = code.match(/^(K1S|K2S|L1S|L2S)(\d{2})([A-Z0-9])/);
    if (newMatch) {
      var prefix = newMatch[1];
      var brandCode = newMatch[2];
      var typeCode = newMatch[3];
      return {
        code: code,
        format: 'Newer alphanumeric',
        collection: NEW_PREFIXES[prefix],
        brand: BRAND_CODES[brandCode] || 'Unknown / undocumented range (' + brandCode + ')',
        type: TYPE_CODES[typeCode] || 'Unknown / undocumented category (' + typeCode + ')',
        range: brandCode,
        tokens: [
          [prefix, NEW_PREFIXES[prefix]],
          [brandCode, BRAND_CODES[brandCode] || 'Range code not in our supported table'],
          [typeCode, TYPE_CODES[typeCode] || 'Garment category not in our supported table']
        ]
      };
    }

    if (/^[A-Z]/.test(code)) {
      return { error: 'This alphanumeric reference is not currently supported by our checker. We only decode prefixes in our current reference table rather than guessing.' };
    }

    if (/^10\d{7,}$/.test(code)) {
      return { error: 'This newer numeric ART reference is not in our audited exact-reference table yet, so we do not guess its season or garment details.' };
    }

    var match = code.match(/^(\d{2})(\d{2})([A-Z0-9])/);
    if (!match) {
      return { error: 'We could not recognise that ART structure. Check the label and enter at least the first five ART characters.' };
    }

    var seasonCode = match[1];
    var rangeCode = match[2];
    var garmentCode = match[3];
    var collection = legacyCollection(seasonCode);

    if (!collection) {
      return { error: 'This numeric season prefix is outside the legacy range supported by our checker. We do not extend the old numeric pattern beyond code 81.' };
    }

    return {
      code: code,
      format: 'Legacy numeric',
      collection: collection,
      brand: BRAND_CODES[rangeCode] || 'Unknown / undocumented range (' + rangeCode + ')',
      type: TYPE_CODES[garmentCode] || 'Unknown / undocumented category (' + garmentCode + ')',
      range: rangeCode,
      tokens: [
        [seasonCode, collection],
        [rangeCode, BRAND_CODES[rangeCode] || 'Range code not in our supported table'],
        [garmentCode, TYPE_CODES[garmentCode] || 'Garment category not in our supported table']
      ]
    };
  }

  function referenceUrl(handle) {
    var safeHandle = String(handle || '').toLowerCase();
    var path = '/pages/stone-island-art/' + encodeURIComponent(safeHandle);
    try {
      var current = new URL(window.location.href);
      var target = new URL(path, window.location.origin);
      ['preview_theme_id', 'pb', '_fd'].forEach(function (key) {
        if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
      });
      return target.pathname + target.search;
    } catch (e) {
      return path;
    }
  }

  function syncUrl(code) {
    try {
      var url = new URL(window.location.href);
      if (code) url.searchParams.set('art', code);
      else url.searchParams.delete('art');
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function injectExactStyles() {
    if (document.getElementById('sg-art-checker-exact-styles')) return;
    var style = document.createElement('style');
    style.id = 'sg-art-checker-exact-styles';
    style.textContent =
      '.sg-art-checker__exact-reference{display:flex;justify-content:space-between;align-items:center;gap:20px;margin-top:14px;padding:16px 17px;border:1px solid rgba(34,111,84,.35);border-left:4px solid var(--sg-green);border-radius:5px;background:#f4f7f5}' +
      '.sg-art-checker__exact-reference[hidden]{display:none!important}.sg-art-checker__exact-copy{min-width:0}' +
      '.sg-art-checker__exact-copy .sg-art-checker__result-label{margin-bottom:4px!important}' +
      '.sg-art-checker__exact-copy h3{margin:0 0 3px!important;color:#111!important;font-family:"Be Vietnam Pro",var(--font-body-family),Arial,sans-serif!important;font-size:15px!important;font-weight:800!important;line-height:1.35!important}' +
      '.sg-art-checker__exact-copy>p:not(.sg-art-checker__result-label){margin:0 0 7px!important;color:#555!important;font-size:11px!important}' +
      '.sg-art-checker__exact-status{display:inline-flex;padding:5px 8px;border-radius:999px;background:#e6f1ec;color:#185840;font-size:9.5px;font-weight:800;letter-spacing:.02em}' +
      '.sg-art-checker__exact-link{flex:0 0 auto;padding:9px 11px;border:1px solid var(--sg-green);border-radius:4px;background:var(--sg-green);color:#fff!important;-webkit-text-fill-color:#fff!important;font-size:10.5px;font-weight:800}' +
      '.sg-art-checker__exact-link:hover,.sg-art-checker__exact-link:focus-visible{border-color:#111;background:#111;color:#fff!important;-webkit-text-fill-color:#fff!important}' +
      '@media(max-width:749px){.sg-art-checker__exact-reference{align-items:flex-start;flex-direction:column;gap:12px;padding:14px}.sg-art-checker__exact-link{width:100%;text-align:center}}';
    document.head.appendChild(style);
  }

  function init(root) {
    var form = root.querySelector('[data-sg-art-form]');
    var input = root.querySelector('[data-sg-art-input]');
    var error = root.querySelector('[data-sg-art-error]');
    var results = root.querySelector('[data-sg-art-results]');
    if (!form || !input || !error || !results) return;

    var fields = {
      code: root.querySelector('[data-sg-art-code]'),
      format: root.querySelector('[data-sg-art-format]'),
      collection: root.querySelector('[data-sg-art-collection]'),
      brand: root.querySelector('[data-sg-art-brand]'),
      type: root.querySelector('[data-sg-art-type]'),
      range: root.querySelector('[data-sg-art-range]'),
      tokens: root.querySelector('[data-sg-art-tokens]')
    };

    var exactBox = document.createElement('div');
    exactBox.className = 'sg-art-checker__exact-reference';
    exactBox.hidden = true;
    exactBox.innerHTML =
      '<div class="sg-art-checker__exact-copy">' +
      '<p class="sg-art-checker__result-label">Audited Street Garms reference</p>' +
      '<h3 data-sg-art-exact-name></h3>' +
      '<p data-sg-art-exact-meta></p>' +
      '<span class="sg-art-checker__exact-status" data-sg-art-exact-status></span>' +
      '</div>' +
      '<a class="sg-art-checker__exact-link" data-sg-art-exact-link hidden>View full ART reference →</a>';

    var grid = root.querySelector('.sg-art-checker__result-grid');
    if (grid) grid.insertAdjacentElement('afterend', exactBox);

    var exactName = exactBox.querySelector('[data-sg-art-exact-name]');
    var exactMeta = exactBox.querySelector('[data-sg-art-exact-meta]');
    var exactStatus = exactBox.querySelector('[data-sg-art-exact-status]');
    var exactLink = exactBox.querySelector('[data-sg-art-exact-link]');

    function showExact(decoded) {
      if (!decoded.exact) {
        exactBox.hidden = true;
        exactLink.hidden = true;
        return;
      }
      var exact = decoded.exact;
      exactName.textContent = exact.name || decoded.code;
      exactMeta.textContent = [exact.season, exact.type, exact.range].filter(Boolean).join(' · ');
      exactStatus.textContent = exact.active
        ? 'High-confidence reference · full details available'
        : 'High-confidence audited reference';
      exactLink.href = referenceUrl(decoded.code);
      exactLink.hidden = !exact.active;
      exactBox.hidden = false;
    }

    function show(raw) {
      var code = cleanCode(raw);
      var exact = exactReference(code);
      var decoded = exact ? decodeExact(code, exact) : decodeGeneric(code);

      error.hidden = true;
      error.textContent = '';
      input.removeAttribute('aria-invalid');

      if (decoded.error) {
        results.hidden = true;
        exactBox.hidden = true;
        input.setAttribute('aria-invalid', 'true');
        error.textContent = decoded.error;
        error.hidden = false;
        syncUrl(code);
        return;
      }

      fields.code.textContent = decoded.code;
      fields.format.textContent = decoded.format;
      fields.collection.textContent = decoded.collection;
      fields.brand.textContent = decoded.brand;
      fields.type.textContent = decoded.type;
      fields.range.textContent = decoded.range;
      var rangeTerm = fields.range && fields.range.parentNode ? fields.range.parentNode.querySelector('dt') : null;
      if (rangeTerm) rangeTerm.textContent = decoded.exact ? 'Reference status' : 'Range code';
      fields.tokens.innerHTML = decoded.tokens.map(function (part) { return token(part[0], part[1]); }).join('');
      showExact(decoded);
      results.hidden = false;
      syncUrl(decoded.code);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      show(input.value);
    });

    root.querySelectorAll('[data-sg-art-example]').forEach(function (button) {
      button.addEventListener('click', function () {
        input.value = button.getAttribute('data-sg-art-example') || '';
        show(input.value);
      });
    });

    try {
      var initial = new URL(window.location.href).searchParams.get('art');
      if (initial) {
        input.value = initial;
        show(initial);
      }
    } catch (e) {}
  }

  function boot() {
    injectExactStyles();
    document.querySelectorAll('[data-sg-art-checker]').forEach(init);
  }

  function loadReferenceIndex(callback) {
    if (window.SG_ART_REFERENCES || !SELF_SRC) {
      callback();
      return;
    }
    var base = SELF_SRC.split('?')[0];
    var src = base.replace(/sg-art-checker\.js$/, 'sg-art-reference-index.js') + '?v=sg-art-ref-1';
    var script = document.createElement('script');
    script.src = src;
    script.onload = callback;
    script.onerror = callback;
    document.head.appendChild(script);
  }

  function start() {
    loadReferenceIndex(boot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
